<template>
<div v-if="documents && documents.length">
    <base-input prepend-icon="ni ni-bullet-list-67">
        <select
            v-model="model.document_type"
            class="form-control"
            @change="onChangeDocument($event)"
            :disabled="blockStudentFields === 1 ? disabled : !disabled"
        >
            <option
                value=""
                selected
                disabled
            >
                {{ $t('login.document_type')}}
            </option>
            <option
                v-for="document in documents"
                :key="document.type"
                :value="document.type"
            >
                {{ document.type }}
            </option>
        </select>
    </base-input>
    <SlideYDownTransition>
        <base-input
            v-if="model.document_type && selectedDocument.mask"
            v-model="model.document"
            v-mask="selectedDocument.mask"
            :v-validate="required ? 'required' : ''"
            :name="$t('login.document')"
            class="mb-3"
            :placeholder="model.document_type"
            prepend-icon="ni ni-badge"
            :error="errors.first(model.document_type)"
            :disabled="blockStudentFields===1 ? disabled : !disabled"
        />
        <base-input
            v-else-if="model.document_type"
            v-model="model.document"
            :v-validate="required ? 'required' : ''"
            :name="$t('login.document')"
            class="mb-3"
            :placeholder="model.document_type"
            prepend-icon="ni ni-badge"
            :error="errors.first(model.document_type)"
            :disabled="blockStudentFields === 1 ? disabled : !disabled"
        />
    </SlideYDownTransition>
</div>
</template>

<script>
import { SlideYDownTransition } from 'vue2-transitions';

import BaseInput from '../../argon/components/Inputs/BaseInput';

export default {
    name: 'DocumentInput',
    components: {
        BaseInput,
        SlideYDownTransition,
    },

    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        value: {
            type: Object,
            default: () => ({}),
        },
        required: {
            type: Boolean,
            default: true,
        },
        blockStudentFields: Number,
    },

    data() {
        return {
            selectedDocument: {},
            disabled: true,
        };
    },

    computed: {
        model: {
            get() { return (this.modelValue !== undefined ? this.modelValue : this.value) || {}; },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },
        documents() {
            return this.$store.getters.DOCUMENTS;
        },
    },

    methods: {
        findDocument(type) {
            return this.documents.find(doc => doc.type === type);
        },
        onChangeDocument(e) {
            this.selectedDocument = this.findDocument(e.target.value);
        },
        setDocumentType() {
            if (this.model && this.model.document_type) {
                this.selectedDocument = this.findDocument(this.model.document_type);
            }
        },
    },

    mounted() {
        this.setDocumentType();
    },
};
</script>
